var _image, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStripeIconCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 16,
  height: 16
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "stripe-icon-circle_svg__a",
  x1: 1,
  x2: 0,
  y1: 0.584,
  y2: 0,
  gradientTransform: "scale(16)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#2697d4",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  style: {
    stopColor: "#207bcb",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#2285ce",
    stopOpacity: 1
  }
})), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAABVElEQVQ4ja2TsUrDUBiFT9JqigQpSKyrbi6KjplcHLIIHfIOoSX0CVzzAA6+QJdurnEplru4ibrKdWyG3haFpN6Q5HdoAjViY9GzXMjP+XL477nAH6WsMad1ACqAWn4W5hRAVgap+K4aAI0xdhQEgTMej3uc8wvP85r5rDJyIwiCHhEltCQppQ9gc0Xqxd8Nw9CzLJvlJi6EGMRx/BiG4fWvAN1ud4eIUiKiMAwf+v3+OYCW4zi7ADaqACqArfl8fruUPoui6M73/VMAWhVAAaB1Op29yWRylabpW0FJkuTVsqxtVCxSBaCNRqMTAK12u304nU5vCshwODwGUF8JsG1bX+xPPgkhBlLKl9wfu65rVCZgjB0Q0Tt9VSqEuATQQKk75YUoAOqe5zVt2z7TdX1fUZQPzvm9aZrPAGIsGvkjoPhW1LiYZ7mRUKryqiupfEj/ok+PsM+9Mw2K8wAAAABJRU5ErkJggg==",
  id: "stripe-icon-circle_svg__b",
  width: 16,
  height: 16
}))), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  style: {
    fill: "url(#stripe-icon-circle_svg__a)",
    stroke: "none"
  }
}), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#stripe-icon-circle_svg__b"
})));
export { SvgStripeIconCircle as ReactComponent };
export default __webpack_public_path__ + "56572d0ec614252a6a0c97353800498f.svg";